export default {
	SubscribedMessagesLimit: 4,
	UnSubscribedMessagesLimit: 2,
};
